import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import Config from '../../config';
var HEIGHT_SIZE_SM = {
  "short": '20px',
  tall: '24px'
};
var HEIGHT_SIZE_MD = {
  "short": '20px',
  tall: '32px'
};
export var StyledTag = withTheme(styled.span.withConfig({
  displayName: "style__StyledTag",
  componentId: "sc-8xmb85-0"
})(["", " ", ";"], function (_ref) {
  var coreTheme = _ref.coreTheme,
    customStyle = _ref.customStyle,
    color = _ref.color,
    size = _ref.size,
    rounded = _ref.rounded;
  return css(["color:", ";background-color:", ";padding:", ";font-family:", ";font-size:12px;height:", ";line-height:1.5;display:inline-flex;justify-content:center;align-items:center;overflow:hidden;", " width:", ";"], coreTheme.cl_white, color, customStyle.width === '100%' ? '0 0px' : '0 16px', coreTheme.ff_sec_bold, HEIGHT_SIZE_SM[size], function () {
    if (rounded) {
      return "border-top-left-radius: ".concat(customStyle.borderTopLeftRadius, ";\n            border-top-right-radius: ").concat(customStyle.borderTopRightRadius, ";\n            border-bottom-left-radius: ").concat(customStyle.borderBottomLeftRadius, ";\n            border-bottom-right-radius: ").concat(customStyle.borderBottomRightRadius, ";");
    }
    return 'border-radius: 0;';
  }, customStyle.width);
}, Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 14px;\n    height: ", ";\n  "])), function (props) {
  return HEIGHT_SIZE_MD[props.size];
})));